export function getUnreadMsg(state) {
    return {
        count : state.messageCount?.count || 0 ,
        isRead: state.messageCount?.isRead || false
    }
}
// export function getGroupUnreadCount(state) {
//     return state.messageCount.isRead;
// }
